import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { submitApproval } from '../../api/approvalApi';
import { useToast } from '../../context/ToastContext';
import { useApproval } from '../../context/ApprovalContext';

export default function SubmitForApprovalButton({
  contentType,
  contentId,
  contentName,
  onSubmitted,
  actionType = 'create',
  onBeforeSubmit,   // optional: return true to say "handled, do not open the confirmation" (e.g. the ad has passed dates to fix first)
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const { addMySubmission } = useApproval();

  const handleSubmit = async () => {
    setConfirmOpen(false);
    setLoading(true);
    try {
      const result = await submitApproval({
        contentType,
        contentId,
        contentName,
        actionType,
      });
      addMySubmission(result?.approvalId);
      toast.success('Submitted for approval!');
      onSubmitted?.();
    } catch {
      // 422 → global handler in ApprovalContext shows NoApproverModal
      // other errors → api-error interceptor shows toast
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<SendIcon sx={{ fontSize: 13 }} />}
        onClick={(e) => { e.currentTarget.blur(); if (onBeforeSubmit?.() === true) return; setConfirmOpen(true); }}
        disabled={loading}
        sx={{
          bgcolor: '#0a326d',
          color: 'white',
          borderRadius: '8px',
          px: 1.5,
          py: 0.6,
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'none',
          lineHeight: 1.3,
          boxShadow: 'none',
          '&:hover': { bgcolor: '#0d3d85', boxShadow: '0 4px 12px rgba(10,50,109,0.25)' },
          '&.Mui-disabled': { bgcolor: 'rgba(10,50,109,0.25)', color: 'white' },
        }}
      >
        {loading ? 'Submitting…' : 'Submit for Approval'}
      </Button>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Submit for Approval?</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            <strong>{contentName || 'This content'}</strong> will be sent to an approver.
            You will not be able to edit it until a decision is made or you withdraw the submission.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button variant="contained" startIcon={<SendIcon />} onClick={handleSubmit}
            sx={{ bgcolor: '#0a326d', '&:hover': { bgcolor: '#0d3d85' } }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}
